import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ClickableClickModule } from 'angular-clickable-click';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangePasswordChallengeComponent } from './auth/change-password-challenge/change-password-challenge.component';
import { FooterModule } from './pages/footer/footer.module';
import { ConfirmDialogComponent } from './services/dialog/confirm-dialog/confirm-dialog.component';
import { CouponQRDialogComponent } from './services/dialog/coupon-qr-dialog/coupon-qr-dialog.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { LoadingDialogComponent } from './services/dialog/loading-dialog/loading-dialog.component';
import { AlertDialogComponent } from './services/dialog/alert-dialog/alert-dialog.component';
import { DisplayErrorComponent } from './services/dialog/display-error/display-error.component';
import { ChooseFileComponent } from './core/custom-modules/choose-file/choose-file.component';
import { GlobalModulesModule } from './core/global-modules/global-modules.module';
import { SingleImageViewerModule } from './core/custom-modules/single-image-viewer/single-image-viewer.module';
import { CampaignWizardModule } from './core/custom-modules/campaign-wizard/campaign-wizard.module';
import { CampaignsModule } from './pages/campaign-module/campaigns/campaigns.module';
import { AllocationModule } from './core/custom-modules/allocation/allocation.module';
import { GroupMaintenanceModule } from './pages/maintenance/group-maintenance/group-maintenance.module';
import { PricelistDownloadModule } from './pages/utilities/pricelist-download/pricelist-download.module';
import { DetailedSettlementReportModule } from './pages/report/detailed-settlement-report/detailed-settlement-report.module';
import { PaymentSummaryReportModule } from './pages/report/payment-summary-report/payment-summary-report.module';
import { SummaryByTerritoryReportModule } from './pages/report/summary-by-territory-report/summary-by-territory-report.module';
import { BranchMaintenanceModule } from './pages/maintenance/branch-maintenance/branch-maintenance.module';
import { BrandMaintenanceModule } from './pages/maintenance/brand-maintenance/brand-maintenance.module';
import { CategoryMaintenanceModule } from './pages/maintenance/category-maintenance/category-maintenance.module';
import { CampaignMaintenanceModule } from './pages/maintenance/campaign-maintenance/campaign-maintenance.module';
import { ItemMaintenanceModule } from './pages/maintenance/item-maintenance/item-maintenance.module';
import { RecipientMaintenanceModule } from './pages/maintenance/recipient-maintenance/recipient-maintenance.module';
import { WebUserModule } from './pages/maintenance/web-user/web-user.module';
import { RoleMaintenanceModule } from './pages/maintenance/role-maintenance/role-maintenance.module';
import { ChainMaintenanceModule } from './pages/maintenance/chain-maintenance/chain-maintenance.module';
import { DeviceMaintenanceModule } from './pages/maintenance/device-maintenance/device-maintenance.module';
import { WebUserRecipientMappingMaintenanceModule } from './pages/maintenance/web-user-recipient-mapping-maintenance/web-user-recipient-mapping-maintenance.module';
import { QuantityPurchasedByDoctorModule } from './pages/report/quantity-purchased-by-doctor/quantity-purchased-by-doctor.module';
import { NewCustomerCountByRecipientModule } from './pages/report/new-customer-count-by-recipient/new-customer-count-by-recipient.module';
import { AllocationAndReceivingRunningBalanceModule } from './pages/report/allocation-and-receiving-running-balance/allocation-and-receiving-running-balance.module';
import { CompanyListModule } from './core/custom-modules/company-list/company-list.module';
import { ConfirmActionComponent } from './core/custom-modules/confirm-action/confirm-action.component';
import { CompanyMaintenanceModule } from './pages/maintenance/company-maintenance/company-maintenance.module';
import { UploadColumnErrorComponent } from './services/dialog/upload-column-error/upload-column-error.component';
import { AreaMaintenanceModule } from './pages/maintenance/area-maintenance/area-maintenance.module';
import { DistrictMaintenanceModule } from './pages/maintenance/district-maintenance/district-maintenance.module';
import { OtpDialogComponent } from './services/dialog/otp-dialog/otp-dialog.component';
import { CouponEntryDialogComponent } from './services/dialog/coupon-entry-dialog/coupon-entry-dialog.component';
import { CouponListDialogComponent } from './services/dialog/coupon-list-dialog/coupon-list-dialog.component';
import { Amplify } from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { ChangeExpiredPasswordComponent } from './auth/change-expired-password/change-expired-password.component';
import { QRCodeModule } from 'angularx-qrcode';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

Amplify.configure({
  Auth: environment.auth,
  API: environment.api
})

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
    ChangePasswordChallengeComponent,
    ConfirmDialogComponent,
    CouponQRDialogComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoadingDialogComponent,
    AlertDialogComponent,
    DisplayErrorComponent,
    ChooseFileComponent,
    ConfirmActionComponent,
    UploadColumnErrorComponent,
    OtpDialogComponent,
    CouponEntryDialogComponent,
    CouponListDialogComponent,
    ChangeExpiredPasswordComponent
  ],
  imports: [
    BrowserModule,
    FooterModule,
    GlobalModulesModule,
    BrowserAnimationsModule,
    SingleImageViewerModule,
    CampaignWizardModule,
    HttpClientModule,
    ClickableClickModule,
    AppRoutingModule,
    CampaignsModule,
    AllocationModule,
    CampaignWizardModule,
    GroupMaintenanceModule,
    PricelistDownloadModule,
    DetailedSettlementReportModule,
    PaymentSummaryReportModule,
    SummaryByTerritoryReportModule,
    BranchMaintenanceModule,
    BrandMaintenanceModule,
    CampaignMaintenanceModule,
    CategoryMaintenanceModule,
    ItemMaintenanceModule,
    RecipientMaintenanceModule,
    RoleMaintenanceModule,
    WebUserModule,
    ChainMaintenanceModule,
    DeviceMaintenanceModule,
    WebUserRecipientMappingMaintenanceModule,
    QuantityPurchasedByDoctorModule,
    NewCustomerCountByRecipientModule,
    AllocationAndReceivingRunningBalanceModule,
    CompanyListModule,
    CompanyMaintenanceModule,
    AreaMaintenanceModule,
    DistrictMaintenanceModule,
    TranslateModule.forRoot({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    QRCodeModule
  ],

  schemas: [ CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    ChangePasswordChallengeComponent,
    ConfirmDialogComponent,
    CouponQRDialogComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoadingDialogComponent,
    AlertDialogComponent,
    DisplayErrorComponent,
    ChooseFileComponent,
    ConfirmActionComponent,
    UploadColumnErrorComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer){
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
    matIconRegistry.addSvgIcon("account-switch", domSanitizer.bypassSecurityTrustResourceUrl('./assets/account-switch.svg'));
    matIconRegistry.addSvgIcon("cellphone-screenshot", domSanitizer.bypassSecurityTrustResourceUrl('./assets/cellphone-screenshot.svg'));
    matIconRegistry.addSvgIcon("download-circle-outline", domSanitizer.bypassSecurityTrustResourceUrl('./assets/download-circle-outline.svg'));
  }
}
